<template>
    <div class="burrito-products">
        <Navbar >
<!--            <template v-slot:navMsg>-->
<!--                <TempAvailabilityMessage />-->
<!--            </template>-->
        </Navbar>

        <section class="bg-light product-section">
            <div class="py-4">
                <div class="container">
                    <Product
                        :product="product"
                    />
                </div>
            </div>
        </section>
        <v-runtime-template :template="product.page_html"></v-runtime-template>

        <!-- <svg class="curve-down" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
            <path d="M0 0 C 50 100 80 100 100 0 Z"></path>
        </svg> -->

        <Footer />
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";


.product-section {
    background-size: cover;
    background-repeat: no-repeat;
}

.product-section .overlay {
    height: 100%;
    background-color: rgba(0, 0, 0, .33);
}

.curve-down path {
    fill: $light;
    stroke: $light;
}

.thb-divider-container {
    position: absolute;
    top: auto;
    bottom: -1px;
    left: -1px;
    width: calc(100% + 2px);
    transform: translateZ(0);
    pointer-events: none;
}

.thb-svg-divider {
    fill: #f8f9fa;
}

.thb-divider-container .thb-svg-divider {
    width: 100%;
    left: 0;
    bottom: -1px;
    height: 100%;
    position: absolute;
}

.thb-divider-container.waves_opacity .thb-svg-divider path:nth-child(2) {
    fill-opacity: 0.15;
}

.thb-divider-container.waves_opacity .thb-svg-divider path:nth-child(3) {
    fill-opacity: 0.3;
}
</style>

<script>
import { mapState } from 'vuex'

import states from '@/common/states'

import Navbar from '@/components/Navbar'
import Product from '@/components/Product'
import Footer from '@/components/Footer'
import VRuntimeTemplate from "v-runtime-template";
import TempAvailabilityMessage from "@/components/TempAvailabilityMessage";



export default {
    name: 'burrito-products',
    data: () => ({
        states: states,
        product: {

        }
    }),
    props: {
        sku: {
            type: String,
            default() {

                switch (this.$route.name){
                    case "civil-rights":
                        return "JTMKIT";
                    break;
                }
                return ""
            }
        }
    },
    computed:mapState({
        backgroundImage () {
            var backgroundImage = null
            if (this.stateData.product_bg) {
                if (
                    this.stateData.product_bg.startsWith('http://') ||
                    this.stateData.product_bg.startsWith('https://') ||
                    this.stateData.product_bg.startsWith('//')
                ) {
                    backgroundImage = this.stateData.product_bg
                } else {
                    backgroundImage = '//' + this.stateData.product_bg
                }
            }
            return backgroundImage
        }
    }),
    components: {
        TempAvailabilityMessage,
        Navbar,
        Product,
        Footer,
        VRuntimeTemplate,
    },    
    watch: {
        '$route': {
            handler (route) {
                if (route.params.sku != this.product.sku) {
                    this.loadSku()
                }
            },
            deep: true,
            immediate: true
        }
    },
    mounted() {
        this.loadSku()
        this.getPublicationResources()
    },
    methods: {
        getPublicationResources () {
            this.$store.dispatch('getPublicationResources')
        },
        loadSku () {
            this.$http({
                'url': `sku/supplemental/${this.sku}`,
                'method': 'get'
            }).then((response) => {
                this.product = response.data.product
                this.product.burrito = true
            }).catch(error => {

                this.$swal({
                    text: error.message,
                    type: 'error'
                })
            })
        }
    }
}
</script>
